import { useEffect, useState } from "react";
import { useNavigate, useParams, Navigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Scissors } from "@phosphor-icons/react";
import { API, getToken, authHeaders } from "@/lib/api";
import { useLocale } from "@/i18n";

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const { t, setLocale } = useLocale();
  const { lang } = useParams();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (lang === "py") setLocale("es");
    else setLocale("pt");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  useEffect(() => {
    if (!getToken()) navigate(lang === "py" ? "/py/entrar" : "/entrar");
  }, [navigate, lang]);

  if (lang && !["br", "py"].includes(lang)) return <Navigate to="/trocar-senha" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.warning(t("cp_too_short"));
    setLoading(true);
    try {
      await axios.post(`${API}/auth/set-password`, { password }, { headers: authHeaders() });
      toast.success(t("cp_success"));
      navigate("/painel");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : t("cp_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50">
      <div className="w-full max-w-md mx-auto px-4 min-h-screen flex flex-col justify-center" data-testid="change-password-page">
        <div className="flex items-center gap-2 text-amber-500 mb-2">
          <Scissors size={22} weight="duotone" />
          <span className="font-display font-bold text-lg">Barber Menu</span>
        </div>
        <h1 className="text-3xl font-black tracking-tight">{t("cp_title")}</h1>
        <p className="text-sm text-zinc-500 mt-2">{t("cp_sub")}</p>
        <form onSubmit={handleSubmit} className="mt-8 space-y-4" data-testid="change-password-form">
          <input
            data-testid="change-password-input"
            type="text"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t("cp_password_ph")}
            autoComplete="off"
            className="w-full h-12 px-4 rounded-lg bg-zinc-900 border border-zinc-800 text-zinc-100 placeholder:text-zinc-600 focus:border-amber-500 focus:ring-1 focus:ring-amber-500 focus:outline-none transition-colors"
          />
          <button
            data-testid="change-password-submit-btn"
            type="submit"
            disabled={loading || password.length < 6}
            className="w-full h-12 rounded-xl bg-amber-500 text-zinc-950 font-bold hover:bg-amber-400 transition-colors active:scale-95 disabled:opacity-60"
          >
            {loading ? t("saving") : t("cp_save")}
          </button>
        </form>
      </div>
    </div>
  );
}
